import { EmptyState } from '@/components/primitives';
import { count, timestamp } from '@/lib/inspectFormat';
import type { NatsConsumer, NatsStream } from '@/types/inspect';

export function ConsumerTable({
  consumers,
  stream,
}: {
  consumers: NatsConsumer[];
  stream: NatsStream;
}) {
  if (consumers.length === 0) {
    return (
      <EmptyState
        title="No consumers"
        sub="Nothing is currently reading this stream. Publishers still write to it."
      />
    );
  }

  return (
    <table className="tbl">
      <thead>
        <tr>
          <th>Consumer</th>
          <th>Filter</th>
          <th>Ack policy</th>
          <th>Ack pending</th>
          <th>Redelivered</th>
          <th>Pending</th>
          <th>Unprocessed</th>
          <th>Last active</th>
        </tr>
      </thead>
      <tbody>
        {consumers.map((consumer) => {
          const unprocessed = stream.lastSeq - consumer.ackFloorStreamSeq;

          return (
            <tr key={consumer.name}>
              <td>
                <div className="tbl-strong mono">{consumer.name}</div>
                <div className="tbl-sub">
                  {consumer.durableName ? 'durable' : 'ephemeral'} ·{' '}
                  {consumer.isPush ? 'push' : 'pull'}
                  {consumer.isPaused ? ' · paused' : ''}
                </div>
              </td>
              <td className="mono tbl-num">
                {consumer.filterSubjects.length > 0 ? consumer.filterSubjects.join(', ') : '—'}
              </td>
              <td>{consumer.ackPolicy}</td>
              <td className="tbl-num" style={consumer.numAckPending > 0 ? { color: 'var(--warn)' } : undefined}>
                {count(consumer.numAckPending)}
              </td>
              <td className="tbl-num" style={consumer.numRedelivered > 0 ? { color: 'var(--warn)' } : undefined}>
                {count(consumer.numRedelivered)}
              </td>
              <td className="tbl-num" style={consumer.numPending > 0 ? { color: 'var(--error)' } : undefined}>
                {count(consumer.numPending)}
              </td>
              <td className="tbl-num">{count(unprocessed > 0 ? unprocessed : 0)}</td>
              <td className="tbl-num">{timestamp(consumer.lastActive)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
